module.exports = __webpack_public_path__ + "static/media/festival_02.b48e1582.jpg";